function calculateHasTooFewItems(breakpointMod: number, columns: number, itemCount: number): boolean {
  return columns + breakpointMod >= itemCount;
}

function calculateSlidesPerView(
    breakpointMod: number,
    columns: number,
    itemCount: number,
    useOffset: boolean = false,
    offsetAmount: number = .15
): number {
  let offset = useOffset ? offsetAmount : 0;

  if (calculateHasTooFewItems(breakpointMod, columns, itemCount)) {
    offset = 0;
  }
  return Math.max(columns + offset + breakpointMod, 1 + offset);
}

export {calculateHasTooFewItems, calculateSlidesPerView};
